import React from 'react';

export const PostCardContainer: React.FC = ({ children }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-3 sm:pt-4">
    {children}
  </div>
);
